/* eslint-disable prettier/prettier */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import Axios from 'assets/remote/axios';
import {
    GET_BASE_SETTINGS,
    UPDATE_BASE_SETTING,
} from '../../actions';
import {
    baseSettings,
    baseSettingError,
    baseSettingSuccess,
} from './actions';


function* errorHandler(error) {
    if ('response' in error) {
        const keys = Object.keys(error?.response?.data?.errors);
        // eslint-disable-next-line no-restricted-syntax
        for (const item of keys)
            yield put(baseSettingError(error?.response?.data?.errors[item][0]));
        yield put(baseSettingError(''));
    } else {
        yield put(baseSettingError(error.message));
        yield put(baseSettingError(''));
    }
}

export function* watchGetBaseSettings() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(GET_BASE_SETTINGS, getBaseSettings);
}

const getBaseSettingsAsync = async (filter) => {
    const r = await Axios.get('/settings', { filter });
    return r?.data;
}

function* getBaseSettings({ payload }) {
    const { filter } = payload;
    try {
        const response = yield call(getBaseSettingsAsync, filter);
        yield put(baseSettings(response.system_configs));
        yield put(baseSettingSuccess('لیست با موفقیت دریافت شد'));
        yield put(baseSettingSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export function* watchUpdateBaseSettings() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(UPDATE_BASE_SETTING, updateBaseSettings);
}

const updateBaseSettingsAsync = async (id, key, value) => {
    const response = await Axios.put(`/settings/${id}`, { key, value })
    return response?.data;
};

function* updateBaseSettings({ payload }) {
    const { id, key, value, settings } = payload;
    try {
        const result = yield call(updateBaseSettingsAsync, id, key, value)
        const subjectIndex = settings.findIndex((obj => obj.id === id));
        settings[subjectIndex].key = key;
        settings[subjectIndex].value = value;
        yield put(baseSettings(settings));
        yield put(baseSettingSuccess(result.message));
        yield put(baseSettingSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchGetBaseSettings),
        fork(watchUpdateBaseSettings),
    ]);
}
